module.exports = __webpack_public_path__ + "img/marmelaedchen-böhnchen_xs.80ca1fc5.jpg";